"use client";

import { useWorkspaceNavigation } from "@/hooks/use-workspace-navigation";
import { routes } from "@/lib/navigation/routes";
import { IconUser } from "@teral/icons";
import { CrumbLink } from "./crumb";

export function AccountCrumb() {
  const workspace = useWorkspaceNavigation();

  return (
    <CrumbLink
      icon={<IconUser className="size-3.5 text-gray-11" />}
      label="Account settings"
      current
      href={routes.account.overview({ workspaceSlug: workspace.slug })}
    />
  );
}
